import MicroModal from 'micromodal';
import Grid from './internal/grid';
import Tablist from './internal/tablist';
import Accordion from './internal/accordion';
import SegmentedControl from './internal/segmented-control';
import Splide from '@splidejs/splide';

var sliders = document.getElementsByClassName("splide");


if (sliders && sliders.length > 0) {
    new Splide('.splide', {
        type: 'loop',
        autoplay: true,
        perPage: 2
    }).mount();
}


MicroModal.init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    disableScroll: true
});

const debugGrid = new Grid("#debug-grid");
debugGrid.init();

new Tablist();
new Accordion();


// Initialize radio button group
window.addEventListener('load', function() {
    var radios = document.querySelectorAll('[role="radiogroup"]');
    for (var i = 0; i < radios.length; i++) {
        new SegmentedControl(radios[i]);
    }
});